import ApiBack from "../../../../utils/domains/ApiBack";
import IPS from "../../../../models/Ips";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import User from "../../../../models/user";
import { jwtDecode } from "jwt-decode";
import Creditor from "../../../../models/Creditor";
import Conciliation from "../../../../models/Conciliation";
import { formatDate } from "../../../../utils/funtions/date";

export const AllData = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [selectedIpsName, setselectedIpsName] = useState<string>("");
    const [selectedCreate, setselectedCreate] = useState<string>("");
    const [selectedType, setselectedType] = useState("");
    const [arrayCreditor, setArrayCreditor] = useState<Creditor[]>([]);
    const [arrayConciliation, setArrayConciliation] = useState<Conciliation[]>([]);
    const [arrayIPS, setArrayIPS] = useState<IPS[]>([]);
    //function to error the Token on the time, using when token is invalid or expired
    const [arrayUsers, setArrayUsers] = useState<User>();
    const [resumen, setResumen] = useState<any>({});
    const [page, setPage] = useState(1);


    // const cleanBox = (form: HTMLFormElement) => {
    //     form.reset();

    //     object.connection = "";
    //     object.password_connection = "";
    //     object.password_server = "";
    //     object.name_server = "";

    //     (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
    //         "";
    //     (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
    //     (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

    //     form.classList.remove("was-validated");
    // };

    const getAllIPS = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW_ACTIVE);
            setArrayIPS(results);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching info IPS:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };
    const handleTokenError = () => {
        navigate("/");
    };
    const [startDateEntry, setStartDateEntry] = useState<string>("");
    const [endDateEntry, setEndDateEntry] = useState<string>("");

    const getAllAcredor = async () => {
        try {
            const results = await ServicePrivate.requestGET(ApiBack.VIEW_ACREEDOR_ALL_NAME);
            setArrayCreditor(results.results);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching info IPS:", error);
            setLoading(false);
            // handleTokenError(error); // Manejar el error de token
        }
    };

    const getAllConciliation = async () => {
        try {
            if (selectedIpsName === "") {
                setArrayConciliation([])
                MessageToastify('error', 'Tienes que seleccionar una IPS primero para poder hacer la busqueda.', 2000)
                return;
            }
            if (startDateEntry === "") {
                setArrayConciliation([])
                MessageToastify('error', 'Tienes que seleccionar una fecha de inicio para poder hacer la busqueda.', 2000)
                return;
            }
            if (endDateEntry === "") {
                setArrayConciliation([])
                MessageToastify('error', 'Tienes que seleccionar una fecha de fin para poder hacer la busqueda.', 2000)
                return;
            }
            if (selectedType === "") {
                setArrayConciliation([])
                MessageToastify('error', 'Tienes que seleccionar un tipo de informe para poder hacer la busqueda.', 2000)
                return;
            }

            if (selectedType === 'Conciliacion') {

                let url =
                    ApiBack.VIEW_CONCILIATION_REPORT +
                    "?ips=" + selectedIpsName +
                    "&date_start=" + startDateEntry +
                    "&date_end=" + endDateEntry;

                if (selectedCreate) {
                    url += "&creditor=" + selectedCreate;
                }

                const results = await ServicePrivate.requestGET(url);

                if (results.total_count === 0) {
                    MessageToastify('info', 'No hay datos de conciliación para la IPS seleccionada en las fechas indicadas.', 5000)
                    return;
                }

                if (results) {
                    const payload = results.results || [];
                    setArrayConciliation(payload);
                    setResumen(results.total_count)
                } else {
                    setLoading(true);
                }
            }
            if (selectedType === 'Pacto') {

                const url = ApiBack.VIEW_PACT_REPORT + "?ips=" + selectedIpsName + "&date_start=" + startDateEntry + "&date_end=" + endDateEntry + "&creditor=" + selectedCreate
                const results = await ServicePrivate.requestGET(url);

                if (results.total_count === 0) {
                    MessageToastify('info', 'No hay datos de conciliación para la IPS seleccionada en las fechas indicadas.', 5000)
                    return;
                }

                if (results) {
                    const payload = results.results || [];
                    setArrayConciliation(payload);
                    setResumen(results.total_count)
                } else {
                    setLoading(true);
                }
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const getProfessionals = async () => {
        try {
            const token: any = localStorage.getItem("access");
            if (!token) {
                handleTokenError();
                return;
            }
            const decoded: any = jwtDecode(token);

            if (decoded && decoded.role) {
                setArrayUsers(decoded);
                setLoading(false);
                return;
            } else {
                console.error("El token no contiene información de usuario válida.");
                handleTokenError();
            }

        } catch (error) {
            console.error("Error fetching professionals:", error);
            setLoading(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };


    const downloadTXT = () => {
        if (!arrayConciliation || arrayConciliation.length === 0) {
            MessageToastify('error', 'No hay datos de conciliación para exportar.', 5000);
            return;
        }

        // Convertir cada registro en una línea con |
        const lines = arrayConciliation.map(item => {
            return [
                item.id_creditor__type_creditor,
                item.id_creditor__document_creditor,
                item.programming,
                formatDate(item.date_conciliation),
                item.modality_conciliation,
                item.id_ips__municipio_id__codigo_municipio,
                item.balance_conciliation,
                item.explanation,
                item.refund,
            ].join("|");
        });

        // Unir líneas con salto de línea
        const textContent = lines.join("\n");

        // Crear un archivo descargable
        const blob = new Blob([textContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        // Crear link y descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = "FT038.txt";
        link.click();

        // limpiar memoria
        URL.revokeObjectURL(url);
    }


    const handleIpsNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedIpsName(event.target.value);
    };

    const handleIpsCreditorChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedCreate(String(event.target.value));
    };

    const handleTypeReport = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setselectedType(event.target.value);
    };



    useEffect(() => {
        getAllIPS();
        getProfessionals();
        getAllAcredor()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12 col-md-6" style={{ userSelect: "none" }}>
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Generador de informes
                                        </h4>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 col-md-6">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            {(selectedType === "Conciliacion") ? (
                                                <>
                                                    <button
                                                        className={
                                                            "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                        }
                                                        type="button"
                                                        onClick={() => downloadTXT()}
                                                        style={{ marginLeft: "10px", userSelect: "none" }}
                                                    >
                                                        <i className="fa-solid fa-file"></i>&nbsp;FT038
                                                    </button>
                                                </>
                                            ) : (
                                                <>

                                                </>
                                            )}
                                            {(selectedType === "Pacto") ? (
                                                <>
                                                    <button
                                                        className={
                                                            "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                        }
                                                        type="button"
                                                        onClick={() => downloadTXT()}
                                                        style={{ marginLeft: "10px", userSelect: "none" }}
                                                    >
                                                        <i className="fa-solid fa-file"></i>&nbsp;FT039
                                                    </button>
                                                </>
                                            ) : (
                                                <>

                                                </>
                                            )}
                                            {(selectedType === "Avance") ? (
                                                <>
                                                    <button
                                                        className={
                                                            "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                        }
                                                        type="button"
                                                        onClick={() => downloadTXT()}
                                                        style={{ marginLeft: "10px", userSelect: "none" }}
                                                    >
                                                        <i className="fa-solid fa-file"></i>&nbsp;FT040
                                                    </button>
                                                </>
                                            ) : (
                                                <>

                                                </>
                                            )}

                                        </div>
                                    </div>
                                    <div className="row" style={{ userSelect: "none" }}>
                                        <div className="d-flex align-items-center col-lg-11 col-md-12">
                                            <div className="row">
                                                <div className="col-lg-6 col-sm-12 col-md-6">
                                                    <Form.Group className="" controlId="formIps">
                                                        <Form.Label className="fw-bold">Seleccionar IPS</Form.Label>
                                                        <Form.Select
                                                            className="select-responsive"
                                                            value={selectedIpsName}
                                                            onChange={handleIpsNameChange}
                                                            onClick={() => {
                                                                //   setArrayAuthDevice([]);
                                                                setPage(0);
                                                                //   setlimit(0);
                                                                //   setTotal(0);
                                                            }}
                                                        >
                                                            <option value="">Todas las IPS</option>
                                                            {arrayIPS.map((type) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.municipio_id.nombre_municipio}&nbsp;-&nbsp;
                                                                    {type.nombre_ips}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6 col-sm-12 col-md-6">
                                                    <Form.Group className="" controlId="selectedCreate">
                                                        <Form.Label className="fw-bold">Seleccionar acreedor</Form.Label>
                                                        <Form.Select
                                                            className="select-responsive"
                                                            value={selectedCreate}
                                                            onChange={handleIpsCreditorChange}
                                                            onClick={() => {
                                                                //   setArrayAuthDevice([]);
                                                                setPage(0);
                                                                //   setlimit(0);
                                                                //   setTotal(0);
                                                            }}
                                                        >
                                                            <option value="">Todas las acreedor</option>
                                                            {arrayCreditor?.map((item) => (
                                                                <option key={item.id} value={String(item.id)}>
                                                                    {item.name_creditor}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-4 col-sm-12 col-md-6">
                                                    <Form.Group className="" controlId="startDateEntry">
                                                        <Form.Label className="fw-bold">Fecha de inicio</Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            // id="startDateEntry"
                                                            value={startDateEntry}
                                                            onChange={(e) => setStartDateEntry(e.target.value)}
                                                            onClick={() => {
                                                                //   setArrayAuthDevice([]);
                                                                setPage(0);
                                                                //   setlimit(0);
                                                                //   setTotal(0);
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-4">
                                                    <Form.Group className="" controlId="startDateEntry">
                                                        <Form.Label className="fw-bold">Fecha de fin</Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            value={endDateEntry}
                                                            onChange={(e) => setEndDateEntry(e.target.value)}
                                                            onClick={() => {
                                                                //   setArrayAuthDevice([]);
                                                                setPage(0);
                                                                //   setlimit(0);
                                                                //   setTotal(0);
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-lg-4">
                                                    <Form.Group className="" controlId="typeReport">
                                                        <Form.Label className="fw-bold">Seleccionar informe</Form.Label>
                                                        <Form.Select
                                                            value={selectedType}
                                                            onChange={handleTypeReport}
                                                            onClick={() => {
                                                                //   setArrayAuthDevice([]);
                                                                setPage(0);
                                                                //   setlimit(0);
                                                                //   setTotal(0);
                                                            }}
                                                        >
                                                            <option value=""></option>
                                                            <option value="Conciliacion">Conciliacion</option>
                                                            <option value="Pacto">Pacto</option>
                                                            <option value="Avance">Avance</option>

                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                            </div>



                                        </div>
                                        <div className="d-flex align-items-center mt-lg-4 col-lg-1 col-sm-12 col-md-12 mb-3">
                                            <Button className="ms-2 mt-3 badge fs-6 p-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill"
                                                variant="primary"
                                                onClick={() => getAllConciliation()}>
                                                <i className="fa-solid fa-magnifying-glass"></i>&nbsp;Buscar
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-center" style={{ userSelect: "none" }}>
                                    <div className="col-lg-3 col-md-6">
                                        <p>
                                            Total de conciliaciones el la busqueda:&nbsp;
                                            <b className="fw-bold">{Array.isArray(arrayConciliation) ? arrayConciliation.length : 0}</b>
                                        </p>

                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>
                                    {arrayConciliation.length === 0 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: "200px", userSelect: "none" }}>
                                            <span className="text-muted">No hay datos de conciliación para mostrar.</span>
                                        </div>
                                    ) : (
                                        <table className="table table-striped table-sm table-hover table-sm">
                                            <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                                <tr>
                                                    <th style={{ width: "15%", cursor: "pointer" }} >Acreedor</th>
                                                    <th style={{ width: "10%" }}>Fecha</th>
                                                    <th style={{ width: "5%" }}>Programación</th>
                                                    <th style={{ width: "15%" }}>Modalidad</th>
                                                    <th style={{ width: "15%" }}>Saldo</th>
                                                    <th style={{ width: "15%" }}>Glosa</th>
                                                    <th style={{ width: "15%" }}>Devolución</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-group-divider ">
                                                {arrayConciliation?.map((myCreditor, count) => (
                                                    <tr key={count + 1}>
                                                        <td>{myCreditor.id_creditor__name_creditor}</td>
                                                        <td>{formatDate(myCreditor.date_conciliation)}</td>
                                                        <td>{myCreditor.programming ? "Sí" : "No"}</td>
                                                        <td>  {{
                                                            1: "Presencial",
                                                            2: "Virtual",
                                                            3: "No aplica"
                                                        }[myCreditor.modality_conciliation] || "Desconocido"}</td>
                                                        <td>{myCreditor.balance_conciliation}</td>
                                                        <td>{myCreditor.explanation}</td>
                                                        <td>{myCreditor.refund}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}


                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    );
};
